import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Printer, Mail, Phone } from "lucide-react";

const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export default function LegalPage({ doc, testid }) {
  useEffect(() => {
    document.title = `${doc.title} | Pickle Bullpen`;
    setMeta("name", "description", doc.description);
    setMeta("property", "og:title", `${doc.title} — Pickle Bullpen`);
    setMeta("property", "og:description", doc.description);
    setMeta("property", "og:url", doc.url);
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
    link.setAttribute("href", doc.url);
    window.scrollTo(0, 0);
  }, [doc]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white px-5 sm:px-8 py-10" data-testid={testid}>
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between gap-3 mb-8 print:hidden">
          <Link to="/" data-testid={`${testid}-back`} className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-zinc-500 hover:text-lime-400"><ArrowLeft className="w-3.5 h-3.5" /> Pickle Bullpen</Link>
          <button data-testid={`${testid}-print`} onClick={() => window.print()} className="inline-flex items-center gap-1.5 border border-zinc-700 hover:border-white px-3 py-2 text-[10px] font-black uppercase tracking-widest text-zinc-300"><Printer className="w-3.5 h-3.5" /> Print / Save PDF</button>
        </div>
        <p className="font-mono text-lime-300 uppercase tracking-[0.3em] text-xs mb-3">{doc.kicker} · Effective {doc.effective}</p>
        <h1 className="font-display font-black uppercase leading-[0.95] text-4xl sm:text-5xl mb-6" data-testid={`${testid}-title`}>{doc.title}</h1>
        <div className="space-y-5 text-sm text-zinc-300 leading-relaxed">
          <div className="border border-lime-400/40 bg-lime-400/5 p-4">
            <div className="text-[10px] uppercase tracking-[0.25em] text-lime-400 font-black mb-2">At a glance</div>
            <ul className="space-y-1.5">{doc.summary.map((s, i) => <li key={i} className="flex gap-2"><span className="text-lime-400">▸</span><span>{s}</span></li>)}</ul>
          </div>
          {doc.sections.map((sec, i) => (
            <section key={i} data-testid={`${testid}-section-${i + 1}`}>
              <h2 className="font-display font-bold uppercase text-white text-base mb-1.5">{sec.h}</h2>
              {sec.p?.map((t, j) => <p key={j} className="mb-2">{t}</p>)}
              {sec.list && <ul className="list-disc pl-5 space-y-1 mb-2">{sec.list.map((t, j) => <li key={j}>{t}</li>)}</ul>}
            </section>
          ))}
        </div>
        <div className="mt-10 border-t border-zinc-800 pt-6 flex flex-wrap gap-5 text-xs text-zinc-400 print:hidden">
          <a href="mailto:admin@picklebullpen.com" className="inline-flex items-center gap-1.5 hover:text-white"><Mail className="w-3.5 h-3.5 text-lime-400" /> admin@picklebullpen.com</a>
          <a href="tel:9418995300" className="inline-flex items-center gap-1.5 hover:text-white"><Phone className="w-3.5 h-3.5 text-lime-400" /> 941-899-5300</a>
          <span className="ml-auto flex gap-4">
            <Link to="/privacy-policy" className="hover:text-lime-400">Privacy</Link>
            <Link to="/terms-of-service" className="hover:text-lime-400">Terms</Link>
            <Link to="/return-policy" className="hover:text-lime-400">Returns</Link>
          </span>
        </div>
      </div>
    </div>
  );
}
